<li 
  appListGroupItem
  class="tree_item py-1 px-2"
  [class]="node().styleClass || ''"
  role="treeitem"
  [attr.aria-selected]="isSelected()"
  [attr.aria-expanded]="node().leaf ? null : !!node().expanded"
  >

  <!-- start node content -->
  <div 
    tabindex="0"
    appListGroupItem
    class="tree_node_content d-flex align-items-center rounded px-3"
    [class.active]="isSelected()"
    [class.tree_node_selected]="isSelected()"
    [class.tree_node_selection]="selectionModeEnabled()"
    [class.tree_node_highligh]="tree.highlightOnSelect()"
    [class.list-group-item-action]="selectionModeEnabled() && tree.highlightOnSelect()"
    [class.tree_node_expanded]="node()?.expanded"
    (keydown)="onKeyDown($event)"
    (click)="onNodeClick($event)"
    (dblclick)="onNodeDoubleClick($event)">

    <button 
      appButton
      size="sm"
      type="button"
      variant="dark"
      appearance="text"
      [rounded]="true"
      [iconOnly]="true"
      class="tree_node_toggle_btn me-1"
      [class.invisible]="node()?.leaf"
      (click)="toggleExpand($event)"
    >
      @let togglerIconTemplate = tree.getTemplate('togglerIconTemplate')?.templateRef || defaultToggler;
      @let loadingIconTemplate = tree.getTemplate('loadingIconTemplate')?.templateRef || defaultLoadingIcon;

      @if (node().loading && tree.loadingMode() === "icon") {
        <span class="tree_node_loading_icon">
          <ng-container *ngTemplateOutlet="loadingIconTemplate; context: { $implicit: node() }"/>
        </span>
      }
      @else {
        <span class="tree_toggler_icon">
          <ng-container *ngTemplateOutlet="togglerIconTemplate; context: { $implicit: node() }"/>
        </span>
      }

    </button>
    
    <!-- start checkbox -->
    @if (selectionModeCheckBox()) {
      <input
        #checkboxRef
        appFormCheckField
        type="checkbox"
        class="tree_node_checkbox me-2"
        [id]="node().key"
        [name]="node().key"
        [checked]="isSelected()"
        [indeterminate]="isIndeterminate()"
        appStopPropagation
        (change)="onNodeClick($any($event))"/>
    }

    <!-- start nodeTemplate -->
    @let nodeTemplate = tree.getTemplate('nodeTemplate')?.templateRef || defaultNode;

    <div class="d-inline-flex flex-grow-1">
      <ng-container *ngTemplateOutlet="nodeTemplate; context: { $implicit: node() }" />
    </div>

  </div>

  <!-- start node children -->
  @if (node().expanded && node().children) {
    <ul appListGroup [flush]="true" class="tree_node_children" role="group">
      @for (child of node().children; track child.key) {
        <app-tree-node [node]="child" />
      }
    </ul>
  }

</li>

<!-- start defaultToggler -->
<ng-template #defaultToggler let-node>
  @if (node.expanded) {
    <i [class]="node.expandedIcon ?? 'fa-chevron-down fa-regular fa-lg'"></i>
  }
  @else {
    <i [class]="node.collapsedIcon ?? 'fa-chevron-right fa-regular fa-lg'"></i>
  }
</ng-template>

<!-- start defaultLoadingIcon -->
<ng-template #defaultLoadingIcon>
  <i class="fa-regular fa-circle-notch fa-spin"></i>
</ng-template>

<!-- start defaultNode -->
<ng-template #defaultNode let-node>
  @if (node.icon) {
    <span class="tree_node_icon me-2">
      <i [class]="node.icon"></i>
    </span>
  }
  <h6 class="mb-0">
    {{ node.label }}
  </h6>
</ng-template>
